import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";

/**
 * What answers an AI task: GENERATIVE (a model that writes) or DECISION (a
 * decision model that answers typed questions). Derived from the generated enum
 * values, so a kind added to the schema reaches this contract without an edit.
 */
export const AITaskKindSchema = z.enum(DbEnum.A_I_TASK_KIND_VALUES);
